import React, { useEffect, useRef, useState } from 'react'

//MUI IMPORTS
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '@mui/material/Switch';
import {
  Chip,
  Box,
  TextField,
  Autocomplete,
  Button,
  DialogActions,
  Grid,
  Typography,
  Paper,
  Fade,
  IconButton,
  Divider,
} from "@mui/material";
import { alpha, styled } from '@mui/material/styles';
import SearchIcon from "@mui/icons-material/Search"
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from "@mui/icons-material/Person"
import CloseIcon from "@mui/icons-material/Close"
import { getData } from '../../../../services/library';

//CUSTOM IMPORTS
import * as api from "../api"
import {hasFullAccess} from "./../../../../utils/filters"


const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#164e63",
    "&:hover": {
      backgroundColor: alpha("#164e63", 0.08),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#164e63",
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#475569",
  },
}))

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  background: "linear-gradient(135deg, #164e63 0%, #0c3a47 100%)",
  color: "#ffffff",
  padding: "16px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  "& .MuiTypography-root": {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "1.25rem",
    fontWeight: 450,
  },
}))

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: "10px 14px",
  backgroundColor: "#f1f5f9",
  borderRadius: "12px",
  marginBottom: "24px",
  border: "1px solid #e2e8f0",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 12px rgba(22, 78, 99, 0.08)",
  },
}))

function DialogBusquedaClientes({ open, setOpen, setDataCliente, setFormData, formData, setItems, setDataDireccion, paramsNegocios, setTipoCbtePosible, userSucData }) {
  const [clientes, setClientes] = useState([]);
  const [direcciones, setDirecciones] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [direccionSeleccionada, setDireccionSeleccionada] = useState(null);
  const [aUsuario, setAUsuario] = useState(!!formData?.aUsuario);
  const [cargando, setCargando] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [noOptionsTextClientes, setNoOptionsTextClientes] = useState("Tipee para buscar clientes...");
  const sucUser = localStorage.getItem("sucursal");

  const timeoutRef = useRef(null);

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = () => {
    setearCliente();
    
    if ((formData.empEmisora !== clienteSeleccionado?.id_empresa) || (formData.sucEmisora !== direccionSeleccionada?.id_sucursal)) {
      alert("El cliente seleccionado no pertenece a la sucursal/empresa predeterminada para este usuario.");
    }
    if (!(/\d/.test(clienteSeleccionado?.cuit))) {
      alert("El cliente seleccionado NO TIENE UN CUIT REGISTRADO. Solo podrá hacerle factura a consumidor final.");
    }
    setOpen(false)
  }

  const setearCliente = () => {
    setDataCliente(clienteSeleccionado);
    setDataDireccion(direccionSeleccionada);
    setFormData((prev) => {
      return {
        ...prev,
        aUsuario: aUsuario,
        tipoCompGen: 1,
        aConsFinal: !clienteSeleccionado?.cuit?.trim()?.length ? 1:0
      }
    });

    setItems([{
      cantidad: "",
      unidadMedida: "",
      descUnidadMedida: "",
      precioUnitario: "",
      totalItem: "",
      idProducto: null,
      stockeable:true
    }])

    getData(`/facturacion_tipos_comprobantes/iva/${Number(clienteSeleccionado.situacion_iva)}`, setTipoCbtePosible)
  }

  const label = { inputProps: { 'aria-label': 'Color switch demo' } };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    !!clienteSeleccionado && !aUsuario && api.fetchDomicilios(clienteSeleccionado, setDirecciones, paramsNegocios);
  }, [clienteSeleccionado])

  const getOptionDisabled=(option)=>{
    const fullAccess = hasFullAccess();
    if(fullAccess) return false;
    
    const matchSucUserCliente = (userSucData.id == clienteSeleccionado.id_sucursal) || (userSucData.id_alias == clienteSeleccionado.id_sucursal);
    if (matchSucUserCliente) return false;

    if((userSucData.id == option?.id_sucursal)||(userSucData.id_alias == option?.id_sucursal)) return false;

    return true;
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            borderRadius: "4px",
            boxShadow: "0 20px 60px rgba(22, 78, 99, 0.15)",
          },
        }}
      >
        <StyledDialogTitle>
          <Typography component="div">
            <SearchIcon sx={{ fontSize: "28px" }} />
            Buscar Cliente
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{
              color: "#ffffff",
              "&:hover": {
                backgroundColor: alpha("#ffffff", 0.1),
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>
        <DialogContent sx={{ padding: "32px", backgroundColor: "#ffffff", mt: 3 }}>
          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
            <StyledPaper elevation={0}>
              <Grid container alignItems="center" justifyContent="space-between" >
                <Grid item xs={8} >
                  <Typography
                    sx={{
                      color: "#164e63",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <PersonIcon sx={{ fontSize: "20px", color: "#475569" }} />
                    Facturar a USUARIO
                  </Typography>
                </Grid>
                <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <CustomSwitch
                    checked={aUsuario}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setAUsuario(checked);
                      setClienteSeleccionado(null);
                      setInputValue("");
                      setClientes([]);
                      setDirecciones([]);
                      setDireccionSeleccionada(null);

                      if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                        timeoutRef.current = null;
                      }
                    }}
                    {...label}
                  />
                </Grid>
              </Grid>
            </StyledPaper>

            <Box>
              <Autocomplete
                disableClearable
                placeholder="Nombre, CUIT o Sisven ID"
                options={clientes}
                loading={cargando}
                loadingText="Cargando..."
                value={clienteSeleccionado}
                inputValue={inputValue}
                onChange={(e, value) => {
                  setClienteSeleccionado(value)
                  setDirecciones([]);
                  setDireccionSeleccionada(null);
                }}
                noOptionsText={noOptionsTextClientes}
                onInputChange={(e, value, reason) => {
                  setClienteSeleccionado(null);
                  setInputValue(value);

                  if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                  }

                  if (value?.length >= 2) {
                    timeoutRef.current = setTimeout(() => {
                      api.fetchAllClientes(
                        value, 
                        setClientes, 
                        aUsuario, 
                        setCargando, 
                        setNoOptionsTextClientes,
                        userSucData
                      )
                      timeoutRef.current = null;
                    }, 300);
                  } else {
                    setNoOptionsTextClientes("Tipee para buscar clientes...");
                    setClientes([]);
                  }
                }}

                getOptionLabel={(option) => {
                  const razonSoc = option?.razon_social.trim()
                  const cuit = option?.cuit?.trim()?.length > 0 ? option?.cuit?.trim()?.replace(/\D/g, '') : "Cuit No Registrado";
                  const sisvenId = option?.sisven_id
                  return (`${razonSoc} (${cuit}) ${sisvenId} `);
                }}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                // renderOption={(props, option) => {
                //   const { key, ...optionProps } = props;

                //   const cuit = option?.cuit?.trim()?.length > 0
                //     ? option?.cuit?.trim()?.replace(/\D/g, '')
                //     : "Cuit No Registrado";

                //   return (
                //     <Box
                //       component="li"
                //       key={key || option.id}
                //       {...optionProps}
                //       sx={{
                //         padding: "12px 16px !important",
                //         borderBottom: "1px solid #f1f5f9",
                //         transition: "all 0.2s ease",
                //         display: "flex",
                //         flexDirection: "column",
                //         alignItems: "flex-start !important",
                //         gap: "4px",
                //         "&:hover": {
                //           backgroundColor: "#f8fafc !important",
                //         },
                //         '&[aria-selected="true"]': {
                //           backgroundColor: alpha("#164e63", 0.08) + " !important",
                //           color: "#164e63",
                //           fontWeight: 600,
                //         },
                //       }}
                //     >
                //       <Box sx={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>
                //         <PersonIcon sx={{ fontSize: "20px", color: "#164e63", flexShrink: 0 }} />
                //         <Typography
                //           sx={{
                //             fontSize: "14px",
                //             fontWeight: 500,
                //             color: "#0f172a",
                //             lineHeight: 1.4
                //           }}
                //         >
                //           {option?.razon_social?.trim()}
                //         </Typography>
                //       </Box>

                //       <Box
                //         sx={{
                //           display: "flex",
                //           alignItems: "center",
                //           gap: "12px",
                //           pl: "30px", // Alineado con el texto de arriba
                //           flexWrap: "wrap"
                //         }}
                //       >
                //         <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                //           <Box component="span" sx={{ fontWeight: 600, color: "#475569" }}>CUIT:</Box> {cuit}
                //         </Typography>

                //         {option?.sisven_id && (
                //           <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                //             <Box component="span" sx={{ fontWeight: 600, color: "#475569" }}>Sisven:</Box> {option.sisven_id}
                //           </Typography>
                //         )}
                //       </Box>
                //     </Box>
                //   );
                // }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                
                  const cuit = option?.cuit?.trim()?.length > 0
                    ? option?.cuit?.trim()?.replace(/\D/g, '')
                    : "Cuit No Registrado";
                
                  return (
                    <Box
                      component="li"
                      key={key || option.id}
                      {...optionProps}
                      sx={{
                        padding: "12px 16px !important",
                        borderBottom: "1px solid #f1f5f9",
                        transition: "all 0.2s ease",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start !important",
                        gap: "4px",
                        "&:hover": {
                          backgroundColor: "#f8fafc !important",
                        },
                        '&[aria-selected="true"]': {
                          backgroundColor: alpha("#164e63", 0.08) + " !important",
                          color: "#164e63",
                          fontWeight: 600,
                        },
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>
                        <PersonIcon sx={{ fontSize: "20px", color: "#164e63", flexShrink: 0 }} />
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#0f172a",
                            lineHeight: 1.4
                          }}
                        >
                          {option?.razon_social?.trim()}
                        </Typography>
                      </Box>
                
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          pl: "30px", // Alineado con el texto de arriba
                          flexWrap: "wrap"
                        }}
                      >
                        <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                          <Box component="span" sx={{ fontWeight: 600, color: "#475569" }}>CUIT:</Box> {cuit}
                        </Typography>
                
                        {option?.sisven_id && (
                          <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                            <Box component="span" sx={{ fontWeight: 600, color: "#475569" }}>Sisven:</Box> {option.sisven_id}
                          </Typography>
                        )}
                
                        {/* Chip para negocio_cliente */}
                        {option?.negocio_cliente && (
                          <Chip
                            label={option.negocio_cliente}
                            size="small"
                            sx={{
                              height: "20px",
                              fontSize: "11px",
                              fontWeight: 500,
                              backgroundColor: "#e0f2fe",
                              color: "#0369a1",
                              border: "1px solid #bae6fd",
                              "& .MuiChip-label": {
                                px: "8px"
                              }
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  );
                }}
              
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cliente "
                    variant="outlined"
                    placeholder="Buscar cliente..."
                    helperText={aUsuario ? "SOLO CLIENTES GENÉRICOS" : ""}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "#ffffff",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#164e63",
                          },
                        },
                        "&.Mui-focused": {
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#164e63",
                            borderWidth: "2px",
                          },
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "#475569",
                        fontWeight: 500,
                        "&.Mui-focused": {
                          color: "#164e63",
                        },
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </Box>
            {
              !aUsuario && (
                <>
                  <Box sx={{ mt: 2 }}>
                    <Autocomplete
                      disabled={!clienteSeleccionado}
                      disableClearable
                      placeholder="Dirección "
                      loadingText="Cargando..."
                      options={direcciones}
                      value={direccionSeleccionada}
                      getOptionDisabled={(option)=> getOptionDisabled(option)} 
                      onChange={(e, value) => {
                        setDireccionSeleccionada(value)
                      }}
                      noOptionsText={"No se encuentran resultados para esta búsqueda..."}
                      getOptionLabel={(option) => option?.direccion_entrega.trim() + (option?.nombre_direccion ? ` (${option?.nombre_direccion.trim()})` : '')}
                      getOpcion
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                          <Box
                            component="li"
                            key={key || option.id}
                            {...optionProps}
                            sx={{
                              padding: "12px 16px !important",
                              borderBottom: "1px solid #f1f5f9",
                              transition: "all 0.2s ease",
                              display: "flex",
                              flexDirection: "column", // Cambiamos a columna para organizar mejor el texto principal y secundario
                              alignItems: "flex-start !important",
                              gap: "4px", // Espacio controlado entre elementos
                              "&:hover": {
                                backgroundColor: "#f8fafc !important",
                              },
                              '&[aria-selected="true"]': {
                                backgroundColor: alpha("#164e63", 0.08) + " !important",
                                color: "#164e63",
                                fontWeight: 600,
                              },
                            }}
                          >
                            {/* Fila principal: Icono + Dirección */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>
                              <LocationOnIcon sx={{ fontSize: "20px", color: "#164e63", flexShrink: 0 }} />
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  color: "#0f172a",
                                  lineHeight: 1.4
                                }}
                              >
                                {option?.direccion_entrega?.trim()}
                                {option.nombre_direccion && (
                                  <Box component="span" sx={{ color: "#64748b", fontWeight: 400, ml: 0.5 }}>
                                    ({option.nombre_direccion})
                                  </Box>
                                )}
                              </Typography>
                            </Box>

                            {/* Fila secundaria: Sucursal con sangría para alinearse con el texto de arriba */}
                            {option.sucursal && (
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: "#64748b",
                                  pl: "30px", // Alinea el texto con la dirección ignorando el ancho del icono
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px"
                                }}
                              >
                                <Box component="span" sx={{ fontWeight: 600, color: "#475569" }}>Sucursal:</Box>
                                {option.sucursal}
                              </Typography>
                            )}
                          </Box>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          disabled={!clienteSeleccionado}
                          {...params}
                          label="Domicilio de entrega"
                          variant="outlined"
                          placeholder="Buscar domicilio..."
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "12px",
                              backgroundColor: "#ffffff",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#164e63",
                                },
                              },
                              "&.Mui-focused": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#164e63",
                                  borderWidth: "2px",
                                },
                              },
                            },
                            "& .MuiInputLabel-root": {
                              color: "#475569",
                              fontWeight: 500,
                              "&.Mui-focused": {
                                color: "#164e63",
                              },
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                          }}
                        />
                      )}
                    />
                  </Box>
                </>
              )
            }

          </form>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "0px 32px 32px",
            gap: "12px",
            backgroundColor: "#ffffff",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!clienteSeleccionado?.id || (!aUsuario && !direccionSeleccionada?.id)}
            sx={{
              borderRadius: "10px",
              padding: "10px 32px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.95rem",
              backgroundColor: "#164e63",
              boxShadow: "0 4px 12px rgba(22, 78, 99, 0.25)",
              "&:hover": {
                backgroundColor: "#0c3a47",
                boxShadow: "0 6px 16px rgba(22, 78, 99, 0.35)",
              },
              "&:disabled": {
                backgroundColor: "#cbd5e1",
                color: "#94a3b8",
              },
            }}
          >
            Seleccionar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default DialogBusquedaClientes;

 // renderOption={(props, option) => (
//   <Box
//     component="li"
//     {...props}
//     key={option.id}
//     sx={{
//       padding: "12px 16px !important",
//       borderBottom: "1px solid #f1f5f9",
//       transition: "all 0.2s ease",
//       "&:hover": {
//         backgroundColor: "#f1f5f9 !important",
//       },
//       '&[aria-selected="true"]': {
//         backgroundColor: alpha("#164e63", 0.08) + " !important",
//         color: "#164e63",
//         fontWeight: 600,
//       },
//     }}
//   >
//     <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
//       <LocationOnIcon sx={{ fontSize: "18px", color: "#475569" }} />
//     </Box>
//     <Typography >{option?.direccion_entrega?.trim()}{" "}{option.nombre_direccion ? `(${option.nombre_direccion})` : ""} </Typography>
//     <Typography sx={{fontSize:12}}> || Sucursal: {option.sucursal}</Typography>

//   </Box>
// )}

  // renderOption={(props, option) => {
  //   const cuit = option?.cuit?.trim()?.length > 0 ? option?.cuit?.trim()?.replace(/\D/g, '') : "Cuit No Registrado";
  //   return (
  //     <Box
  //       component="li"
  //       {...props}
  //       key={option.id}
  //       sx={{
  //         padding: "12px 16px !important",
  //         borderBottom: "1px solid #f1f5f9",
  //         transition: "all 0.2s ease",
  //         "&:hover": {
  //           backgroundColor: "#f1f5f9 !important",
  //         },
  //         '&[aria-selected="true"]': {
  //           backgroundColor: alpha("#164e63", 0.08) + " !important",
  //           color: "#164e63",
  //           fontWeight: 600,
  //         },
  //       }}
  //     >
  //       <PersonIcon sx={{ fontSize: "18px", color: "#475569" }} />
  //       {option?.razon_social?.trim()} ({cuit})
  //       <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
  //         <Typography>
  //           {option?.sisven_id && (
  //             <Typography
  //               component="span"
  //               sx={{
  //                 color: "#475569",
  //                 fontSize: "0.85rem",
  //                 fontWeight: 400,
  //               }}
  //             >
  //               -Sisven: {option?.sisven_id}
  //             </Typography>
  //           )}
  //         </Typography>
  //       </Box>
  //     </Box>
  //   )
  // }}